/** @jsx jsx */
import { Box, jsx, Container, Flex, Link, useColorMode } from 'theme-ui'
// import useEmiliaConfig from '../hooks/use-emilia-config'
// @ts-ignore
import AboutMeMDX from '../texts/about-me'
// @ts-ignore
import ContactMeMDX from '../texts/contact-me'
// @ts-ignore
import GroupShowsMDX from '../texts/group-shows'
// @ts-ignore
import WorkshopsMDX from '../texts/workshops'

// @ts-ignore
import ProjectsMDX from '../texts/projects'

import Contact from './contact'

const Footer = () => {
  // const { showThemeAuthor } = useEmiliaConfig()
  const [colorMode, setColorMode] = useColorMode()
  const isDark = colorMode === `dark`

  return (
    <Box
      as="footer"
      variant="layout.footer"
      sx={{
        background: `linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, ${isDark ? `0.35` : `0.15`
          }) 100%)`,
      }}
    >
      <Container>
        <div
          sx={{
            display: `grid`,
            gridGap: 4,
            // gridTemplateColumns: [`1fr`, `1fr`, `1fr`, `2fr 1fr`],
          }}
        >
          <div
            sx={{
              p: { mb: 0 },
              h2: {
                mt: 0,
                mb: 1,
              },
            }}
          >
            <div id="about"></div>
            <AboutMeMDX />
          </div>
          <div
            sx={{
              p: { mb: 0 },
              h2: {
                mt: 0,
                mb: 1,
              },
            }}
          >
            <div id="group-shows"></div>
            <GroupShowsMDX />
            <div id="projects"></div>
            <ProjectsMDX />
            <div id="workshop"></div>
            <WorkshopsMDX />
            <div id="contact"></div>
            <ContactMeMDX />
            <Contact />
          </div>
        </div>
        <Flex
          sx={{
            textAlign: [`center`, `center`, `center`, `right`],
            flexDirection: `column`,
            justifyContent: `space-between`,
          }}
        >
          <div sx={{ mt: [4, 4, 4, 0] }}>
            <div sx={{ color: `textMuted` }}>
              Copyright &copy; {new Date().getFullYear()}. All rights reserved.
            </div>
          </div>
        </Flex>
      </Container>
    </Box>
  )
}

export default Footer
